import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import thunk from "redux-thunk";
import createRootReducer from "../reducers";
import { createBrowserHistory } from "history";
import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import { routerMiddleware } from "connected-react-router";

const history = createBrowserHistory();
const expireReducer = require('redux-persist-expire');

const persistConfig = {
  key: "pmk",
  storage,
  whitelist: ["userAccount"],
  transforms: [
    expireReducer('preference', {
      expireSeconds: 3600
  })]
};

const persistedReducer = persistReducer(
  persistConfig,
  createRootReducer(history)
);

// // Create persisted reducers using redux-persist
// const persistedReducer = persistReducer({
//   transforms: [
//     expireReducer('preference', {
//       expireSeconds: 3600
//   })
//   ]
// },
// persistConfig,
// createRootReducer(history)
// );

export function configureStore(preloadedState) {
  const composeEnhancer =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const store = createStore(
    persistedReducer,
    preloadedState,
    composeEnhancer(applyMiddleware(routerMiddleware(history), thunk))
  );

  return store;
}

const store = configureStore();
const persistor = persistStore(store);

export { history, store, persistor };
